import React from 'react';
import { BrowserRouter as Router, Link, Switch, Route } from 'react-router-dom';
import { LinkedIn } from '@material-ui/icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Nav, Navbar } from 'react-bootstrap';
import './navBar.css';
import DLogo from '../assets/logo/D-letter-logo.png';
import Home from '../home/Home';
import ArticleIterableCards from '../article/articleIterableCards.js';
import Course from  '../course/course.js';
import Products from '../products/products.js';
import DigitalMarketing from '../digitalMarketing/digitalMarketing.js';
import SoftwareDevelopment from '../softwareDevelopment/softwareDevelopment.js';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Router>
        <div className="NavBar">
          <header class="NavBar-header">
            <Navbar collapseOnSelect expand="lg" className="NavBarClass">
              <Navbar.Brand href="/home"><img src={DLogo}
                className="Matrix-logo" alt="logo" />
              </Navbar.Brand>

              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                <Link to="/softwaredevelopment" className="navLink"> 
                  &nbsp; Software Development Service! &nbsp; </Link>
                <Link to="/digitalMarketing" className="navLink"> 
                  &nbsp; Digital Marketing! &nbsp; </Link>
                  <Link to="/course" className="navLink" > 
                  &nbsp; What We Teach? &nbsp; </Link>
                  <Link to="/article" className="navLink" >
                    &nbsp; What We Write? &nbsp;</Link>
                  <a href="https://www.linkedin.com/in/danyson/details/projects/" className="navLink" >
                    &nbsp; What We Build? &nbsp;
                  </a>
                  <Link to="/products" className="navLink" >
                    &nbsp; What We Sell? &nbsp;</Link>
                  <a href="https://www.linkedin.com/services/page/a28237309a41682071/" className="navLink" >
                    &nbsp; Book Our Service Thru <LinkedIn fontSize="large" color="primary" />!&nbsp;
                  </a>
                  <a href="mailto:danysontech@gmail.com" className="navLink">
                    &nbsp; Email Us Now! &nbsp;</a>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </header>
        </div>

        <Switch>
          <Route exact path="/home" render={() => <Home />}></Route>
          <Route exact path="/" render={() => <Home />}></Route>
          <Route exact path="/article" render={() => <ArticleIterableCards />}></Route>
          <Route exact path="/course" render={() => <Course />}></Route>
          <Route exact path="/products" render={() => <Products />}></Route>
          <Route exact path="/digitalMarketing" render={() => <DigitalMarketing />}></Route>
          <Route exact path="/softwaredevelopment" render={() => <SoftwareDevelopment />}></Route>
        </Switch>
      </Router>
    );
  }
}


export default NavBar;

